module.exports = __webpack_public_path__ + "img/sticker-logo.5020259c.png";